"use strict";

angular.module("customer")
.controller("OrderConfirmationController", function(
    $window, $rootScope, $scope, $stateParams, $state, $q, $cookies, ZebraPrinterService, InvoiceService, appConfig,
    InvoicePrintButtonService, CartVendorService, UserService, FlashBag, ModalService, gettextCatalog,
    INVOICE_ATTACHMENTS_MAX
) {
    $scope.order = $stateParams.order;
    $scope.displayErrorMessage = $stateParams.display_error_message;
    $scope.orderList = $scope.order.orders;
    $scope.showViewInvoicesButton = $stateParams.show_view_invoices_button;
    $scope.showInvoicePrintButtons = $stateParams.show_invoice_print_buttons;
    $scope.defaultInvoicePrintFormat = InvoicePrintButtonService.PDF_RECEIPT_FORMAT;
    $scope.invoiceService = InvoiceService;
    $scope.showPaymentButton = false;

    UserService.isUserFetched().then(function onSuccess(user) {
        $scope.dedicatedVendorId = user.dedicated_vendor_id;
        if ($scope.showInvoicePrintButtons && $scope.orderList.length === 1 && $scope.orderList[0].invoice) {
            var invoiceId = $scope.orderList[0].invoice;
            var promise;
            if (ZebraPrinterService.isSupported()) {
                promise = InvoicePrintButtonService.printReceiptPDF(invoiceId, InvoiceService, false, $scope.dedicatedVendorId);
            }
            else {
                promise = InvoicePrintButtonService.downloadInvoicePDF(invoiceId, $scope.defaultInvoicePrintFormat, InvoiceService);
            }
            promises.push(promise);
        }
    });

    var promises = [];

    $q.all(promises).then(function onSuccess() {
        var orderModifyRedirectUrl = $cookies.get("vendor_orders_url");
        if (orderModifyRedirectUrl) {
            $cookies.remove("vendor_orders_url", {domain: appConfig.ROOT_DOMAIN});
            $window.location.href = orderModifyRedirectUrl + "?order_modified=" + $scope.orderList[0].PONumber;
        }
        else if ($scope.order.customer.allows_invite_to_register) {
            $rootScope.$broadcast("doInviteToRegister", $rootScope.user.customer.id);
        }
    });

    if ($scope.displayErrorMessage) {
        $scope.errorsDetail = $stateParams.order.errors_detail;
        $scope.warningsDetail = $stateParams.order.warnings_detail;
        $scope.showPaymentButton = CartVendorService.isPaymentTermsError($stateParams.order);
        $scope.showPreAuthorizedPaymentAgreementAlert = CartVendorService.isPreAuthorizedPaymentAgreementError($stateParams.order);
        $scope.preAuthorizedError = CartVendorService.getFirstPreAuthorizedPaymentAgreementError($stateParams.order);
    }

    function groupOrdersByVendor() {
        var temp = _.groupBy($scope.orderList, function(order) {
            return order.vendor_name;
        })
        $scope.groupedOrders = angular.fromJson(temp);
    }

    this.goTo = function(state, params) {
        $state.go(state, params, {location: 'replace'});
    };

    $scope.invoicesWithAttachmentCount = []
    this.onAddAttachment = function(data) {
        var invoiceId = data['invoiceId'];
        if ($scope.invoicesWithAttachmentCount[invoiceId]) {
            $scope.invoicesWithAttachmentCount[invoiceId] += 1;
        }
        else {
            $scope.invoicesWithAttachmentCount[invoiceId] = 1;
        }
        FlashBag.success(gettextCatalog.getString("Attachment successfully added."));
    }

    this.isInvoiceAttachmentButtonDisabled = function(invoiceId) {
        if ($scope.invoicesWithAttachmentCount[invoiceId]) {
            return $scope.invoicesWithAttachmentCount[invoiceId] >= INVOICE_ATTACHMENTS_MAX;
        }
        return false;
    };

    groupOrdersByVendor();
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/order/order-confirmation.controller.js
// module id = 906
// module chunks = 0